<template>
  <div>
    <Navbar />

    <section class="hero-banner">
      <div class="banner-bg">
        <img src="@/assets/banner/background.png" alt="CNC Machining" />
      </div>

      <div class="banner-overlay"></div>

      <div class="container">
        <div class="banner-content">
          <h1 class="banner-title">
            Custom Manufacturing<br />
            Services Done Right
          </h1>

          <ul class="feature-list">
            <li class="feature-item">
              <span class="check-icon">✓</span>
              Custom mechanical parts as fast as 1-3 day
            </li>
            <li class="feature-item">
              <span class="check-icon">✓</span>
              Precision CNC machined parts from prototype to production
            </li>
            <li class="feature-item">
              <span class="check-icon">✓</span>
              Engineering support & DFM review before production
            </li>
            <li class="feature-item">
              <span class="check-icon">✓</span>
              Small batch to mass production, flexible MOQ
            </li>
          </ul>

          <div class="banner-buttons">
            <button class="btn-primary" @click="$router.push('/quote')">
              <span>
                Get Free Pricing <i class="el-icon-right"></i>
              </span>
            </button>
            
            <!-- Added WhatsApp Button -->
          
            <a href="https://wa.me/+8619129363409" target="_blank" class="btn-whatsapp">
              <span>
                <i class="el-icon-chat-dot-round"></i> Chat via WhatsApp
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
    
    <Manufacturing_Capabilities_Section />
    <WhyChoose/>
    <INDUSTRIES_SERVE/>
    <HowWeWork/>
    <reviews/>
    <faq/>
    <together/>
    <Footer />
  </div>
</template>

<script>
import Footer from './components/Footer.vue';
import Navbar from './components/Nav.vue';
import Manufacturing_Capabilities_Section from './components/Manufacturing_Capabilities_Section.vue';
import WhyChoose from './components/Whychoose.vue';
import INDUSTRIES_SERVE from './components/INDUSTRIES_SERVE.vue';
import together from './components/together.vue';

import HowWeWork from './components/HowWeWork.vue';
import reviews from './components/reviews.vue';
import faq from './components/faq.vue';

export default {
  name: 'HomePage',
  components: { 
    Footer, 
    Navbar,
    Manufacturing_Capabilities_Section,
    WhyChoose,
    INDUSTRIES_SERVE,
    together,
    HowWeWork,
    reviews,
    faq
  },
  setup() {
  },
};
</script>

<style scoped>
/* ========================================================
   基础样式 (默认应用于桌面端)
   ======================================================== */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.hero-banner {
  position: relative;
  margin-top: -45px;
  width: 100%;
  height: 550px;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.banner-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.banner-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 60px;
  position: relative;
  z-index: 2;
}

.banner-content {
  max-width: 600px;
}

.banner-title {
  font-size: 44px;
  font-weight: 600;
  color: #16bc9c;
  line-height: 1.1;
  margin-bottom: 24px;
}

.feature-list {
  list-style: none;
  margin: 0 0 30px 0;
  padding: 0;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  font-size: 16px;
  color: #fff;
  margin-bottom: 10px; 
  line-height: 1.5; 
  font-weight: 600;
}

.check-icon {
  color: #16bc9c;
  font-weight: bold;
  margin-right: 12px;
  font-size: 20px;
  flex-shrink: 0; 
  height: 24px;
  display: inline-flex;
  align-items: center; 
  margin-top: 0; 
}

.banner-buttons {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.btn-primary {
  position: relative;
  padding: 10px 30px;
  background: linear-gradient(90deg, #16bc9c, #0e957b);
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(22, 188, 156, 0.25);
  animation: breathe 2.5s ease-in-out infinite;
  transition: transform 0.2s ease;
  z-index: 1;
}

.btn-primary span {
  position: relative;
  z-index: 2;
}

.btn-primary::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: #027062;
  transition: all .4s;
  z-index: 0;
}

.btn-primary:hover::before {
  left: 0;
}

/* 添加的 WhatsApp 按钮样式 */
.btn-whatsapp {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 30px;
  background: transparent;
  color: #fff;
  border: 2px solid #fff;
  border-radius: 4px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease;
  z-index: 1;
}

.btn-whatsapp span {
  display: flex;
  align-items: center;
  gap: 8px; /* 图标与文字的间距 */
}



@keyframes breathe {
  0% { box-shadow: 0 0 6px rgba(22, 188, 156, 0.25), 0 0 12px rgba(22, 188, 156, 0.15); }
  50% { box-shadow: 0 0 18px rgba(22, 188, 156, 0.55), 0 0 36px rgba(22, 188, 156, 0.25); }
  100% { box-shadow: 0 0 6px rgba(22, 188, 156, 0.25), 0 0 12px rgba(22, 188, 156, 0.15); }
}

/* ========================================================
   1. xl: 超大屏幕 (>= 1920px)
   ======================================================== */
@media (min-width: 1920px) {
  .hero-banner {
    height: 600px; 
  }
  .banner-title {
    font-size: 52px;
  }
}

/* ========================================================
   2. md: 中等屏幕 (>= 992px && < 1200px)
   ======================================================== */
@media (min-width: 992px) and (max-width: 1199px) {
  .hero-banner {
    height: 500px;
  }
  .banner-title {
    font-size: 40px;
  }
  .container {
    padding: 0 60px;
  }
}

/* ========================================================
   3. sm: 平板屏幕 (>= 768px && < 992px)
   ======================================================== */
@media (min-width: 768px) and (max-width: 991px) {
  .hero-banner {
    height: 450px;
  }
  .banner-title {
    font-size: 36px;
  }
  .container {
    padding: 0 20px;
  }
}

/* ========================================================
   4. xs: 超小屏幕 / 手机 (< 768px)
   ======================================================== */
@media (max-width: 767px) {
  .hero-banner {
    height: auto;
    padding: 80px 0 60px 0; 
  }
  
  .banner-title {
    font-size: 30px;
    margin-bottom: 20px;
  }

  .feature-item {
    font-size: 14px;
    margin-bottom: 12px;
  }

  .check-icon {
    font-size: 18px;
    margin-right: 10px;
    height: 21px; 
    margin-top: 0; 
  }

  .container {
    padding: 0 20px;
  }

  .banner-buttons {
    flex-direction: column;
    width: 100%;
  }

  /* 保证两个按钮在移动端都是 100% 宽度居中 */
  .btn-primary, 
  .btn-whatsapp {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
</style>